import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CurrencyFormat from 'react-currency-format';

import { useHistory } from 'react-router-dom';
import styled from 'styled-components'
import Rating from '@material-ui/lab/Rating';
import Box from '@material-ui/core/Box';
import Button from 'web/components/Button';
import DropDown from 'web/components/DropDown';
import premium_star from 'web/assets/images/premium_star.png';
// import card1 from 'web/assets/images/pallet-home-image.webp';
import card1 from 'web/assets/images/pallet-home-image.jpg';
import reseller from 'web/assets/images/reseller.png';
import RightArrowLight from "web/assets/images/right-arrow-sell.png";

import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import styles from './featured.module.scss';
import { fetchLanguageContentNew } from 'redux/actions/language';

const Featured = ({ totalRecord, pageType, response, outOf, title, currentPage, tabType, onChangeHandler, onWishListChangeHandler }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const fileUrl = process.env.REACT_APP_API_URL + '/user/image/';
  const isGuestUser = localStorage.getItem('accountType')
  const [searchDropDown, setSearchDropDown] = useState('PostInventory');
  const [searchDropDownSorting, setSearchDropDownSorting] = useState('NEAREST');
  let disableFlg = localStorage.getItem('disableFlg')
  const [setTimer, setTimerState] = useState(false);

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()
  const [dropDownArr, setDropDownArr] = useState([])
  const [dropDownArr2, setDropDownArr2] = useState([])

  useEffect(() => {
    if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  useEffect(() => {
    setDropDownArr([
      {
        id: '0',
        // label: pageLanguageContents?.HeaderContents[1]?.OldPost,
        label: 'Sort by Newest',
        value: 'NEWEST',
      },
      {
        id: '1',
        label: 'Sort by Nearest',
        value: 'NEAREST',
      },
    ])

    setDropDownArr2([
      {
        id: '0',
        label: pageLanguageContents?.HeaderContents[4]?.WishNeeds,
        value: 'PostLoad',
      },
      {
        id: '1',
        label: pageLanguageContents?.HeaderContents[5]?.WishOffers,
        value: 'PostInventory',
      },
    ])

  }, [pageLanguageContents])

  const onClickHandler = (e, index) => {
    localStorage.setItem('myPostPage', '')
    let obj = {
      id: response[index]?.id.toString(),
      postType: pageType.toString(),
    }

    dispatch({ type: 'DETAILS', payload: obj })

    history.push({
      pathname: '/details',
      // search: '?id=' + response[index].id.toString() + '&postType=' + pageType.toString(),
    })
  }

  useEffect(() => {
    setTimeout(
      () => {
        if (response.length === 0)
          setTimerState(true)
      },
      3000
    );
  })
  let selectedPage = tabType
  if (!selectedPage) {
    selectedPage = pageType
  }
  if (pageType === "PostLoad") {
    selectedPage = "Pallet Needs"
  }

  const capitalize = (s) => {
    if (typeof s !== 'string')
      return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  const arrowSign = () => {
    return <img
      src={RightArrowLight}
      alt="RightArrow"
      className={styles.rightArrow}
    />
  }

  const sizeAttach = (tabType, value) => {
    let size = value?.palletDetail?.size
    if(value?.palletDetail?.size === "31.5x47.2(1.2mx0.8m)"){
      size="31.5x47.2"
    }
    if(value?.palletDetail?.size === "47.2x39.4(1.2mx1.0m)"){
      size="47.2x39.4"
    }

    return <>
      {tabType === "WishList" ? (
        <>{value?.commodity?.callGrade ? <>{value?.grade?.sizeWiseGrad ? '' : ''}</> : ''}:{value?.grade?.sizeWiseGrad ? value?.grade?.sizeWiseGrad :
          <>{value?.grade?.gradeName ? value?.grade?.gradeName :
            <>{value?.commodityDim?.width ? value.commodityDim?.length + 'x' + value.commodityDim?.width + 'x' + value.commodityDim?.height : 'NA'}</>
          }</>
        }</>
      ) : (
        <>
          {value?.palletDetail?.grade ?
            <>{" "}{value?.palletDetail?.grade}</>
            :
            value?.palletDetail?.size ?
              <>{" "}{size}</>
              : <>{"NA"}</>
          }
        </>
      )}
    </>
  }
  let count = outOf ? outOf : 9
  return (
    <div className={styles.featuredSection}>
      <DropdownContainer>
        <div className={styles.dropDown}>
          <DropDown
            name="dropDown"
            data={dropDownArr}
            searchDropDown={searchDropDownSorting}
            placeholder={pageLanguageContents?.HeaderContents[0]?.SortByPost
            }
            onChangeHandler={(event) => {
              setSearchDropDownSorting(event.value);
              onChangeHandler(event.value);
            }}
          />
          {tabType === "WishList" && (
            <DropDown
              name="dropDownWishList"
              data={dropDownArr2}
              searchDropDown={searchDropDown}
              placeholder={pageLanguageContents?.HeaderContents[3]?.WishList}
              onWishListChangeHandler={(event) => {
                setSearchDropDown(event.value);
                onWishListChangeHandler(event.value);
              }}
            />
          )}
          {totalRecord !== 0 && totalRecord !== "" ? (
            <>
              {totalRecord <= currentPage * count ? (
                <>
                  {totalRecord >= count ? (
                    <h6>
                      {pageLanguageContents?.HeaderContents[6]?.Showing}{" "}
                      {currentPage === 1 ? 1 : <>{(currentPage - 1) * count + parseInt(1)} </>}{" "}
                      -{totalRecord} {pageLanguageContents?.HeaderContents[7]?.OutOf} {totalRecord}
                    </h6>
                  ) : (
                    <h6>
                      {pageLanguageContents?.HeaderContents[6]?.Showing} 1-{totalRecord} {pageLanguageContents?.HeaderContents[7]?.OutOf} {totalRecord}
                    </h6>
                  )}
                </>
              ) : (
                <>
                  {totalRecord >= count ? (
                    <h6>
                      {pageLanguageContents?.HeaderContents[6]?.Showing}{" "}
                      {currentPage === 1 ? 1 : <>{(currentPage - 1) * count + parseInt(1)} </>}-
                      {currentPage * count} {pageLanguageContents?.HeaderContents[7]?.OutOf} {totalRecord}
                    </h6>
                  ) : (
                    <h6>
                      {pageLanguageContents?.HeaderContents[6]?.Showing} 1-{totalRecord} {pageLanguageContents?.HeaderContents[7]?.OutOf} {totalRecord}
                    </h6>
                  )}
                </>
              )}
            </>
          ) : (
            <h6></h6>
          )}
        </div>
      </DropdownContainer>

      {response && response?.length !== 0 ? (
        <>
          <div className={`${styles.imgSection} ${isGuestUser === 'Guest' && styles.imgSectionGuest}`}>
            {response.map((value, index) => (
              <div className={value?.palletDetail?.fcMember ? styles.withYellowBorder : styles.normalBorder} onClick={(e) => onClickHandler(e, index)} key={index}>
                {value?.recurringType === "ORDER_RECURRING" ? (<>
                  <p className={styles.tag}>
                    {arrowSign()}
                    {value?.isReseller && (
                      <SellerIconWrapper>
                        <span>
                          <img src={reseller} alt="reseller" />
                          <span style={{ lineHeight: '10px' }}>{pageLanguageContents?.TilesContents[4]?.Reseller}</span>
                        </span>
                      </SellerIconWrapper>
                    )}
                    {value?.private && (!disableFlg || disableFlg === 'false') && <span className={styles.orange}>
                      {pageLanguageContents?.TilesContents[3]?.PrivatePost}
                    </span>}
                    {value?.recurringType === "ORDER_RECURRING" && !value?.private && <span className={styles.purple}>Recurring Order</span>}
                    {/*{value.postCreatedWithRecurring && !value.isRecurring && <span className={styles.purple}>Recurring Post</span>} */}
                    {value?.isFavorite ? (
                      <>
                        <FavoriteIcon className='fav-icon' style={{ color: "#cd181d" }} />
                      </>
                    ) : (
                      <>
                        <FavoriteBorderOutlinedIcon className='fav-icon' />
                      </>
                    )}
                  </p>
                </>
                ) : (
                  <p className={styles.tag}>
                    {value.status === "BIDDING_CLOSE" ? (<>
                      {arrowSign()}
                      <span className={styles.orange}>{pageLanguageContents?.TilesContents[1]?.Closed}</span>

                    </>
                    ) : (
                      <>
                        {value?.private && (!disableFlg || disableFlg === 'false') ? (<>
                          {arrowSign()}
                          <span className={styles.orange}>
                            Private Post
                          </span>
                        </>
                        ) : (<>
                          {arrowSign()}
                        </>
                        )}
                      </>
                    )}

                    {value?.isReseller && (
                      <SellerIconWrapper>
                        <span>
                          <img src={reseller} alt="reseller" />
                          <span style={{ lineHeight: '10px' }}>{pageLanguageContents?.TilesContents[4]?.Reseller}</span>
                        </span>
                      </SellerIconWrapper>
                    )}
                    {value?.palletDetail?.fcMember && (
                      <InnerCircleIconWrapper>
                        <span>
                          <img src={premium_star} alt="star" />
                        </span>
                      </InnerCircleIconWrapper>
                    )}
                    {value.isFavorite ? (
                      <>
                        <FavoriteIcon className='fav-icon' style={{ color: "#cd181d" }} />
                      </>
                    ) : (
                      <>
                        <FavoriteBorderOutlinedIcon className='fav-icon' />
                      </>
                    )}
                  </p>
                )}

                <div className={styles.img}>
                  <img src={value?.uploadImage && value?.uploadImage.length > 0 ? `${fileUrl}${value?.uploadImage[0]}` : card1} alt="img" />
                </div>
                <div className={styles.textSection}>

                  <p className={styles.itemName}>{value?.palletDetail?.title}</p>
                  <p className={styles.itemPrice}>
                    {tabType === "WishList" ? (
                      <>
                        <>{value.commodity?.commodityName ? value.commodity.commodityName : 'Custom'} {sizeAttach(tabType, value)}</>
                      </>
                    ) : (
                      <>
                        {value?.palletDetail?.commodity ? value?.palletDetail?.commodity :
                          value?.palletDetail?.material === 'PLASTIC' ? 'Plastic' :
                            'Custom'} {sizeAttach(tabType, value)}
                      </>
                    )}
                  </p>
                  <p className={styles.itemPrice}>Located in {value?.state}</p>

                  {/* <>{value?.deliveryType ==='PICKUP'?<p>Pickup near {value?.zipCode}</p>:<>
                    <p>Willing to delivery</p>
                    </>}
                  </> */}
                  {/* <p className={styles.itemPrice}>
                           {value?.deliveryType ==='PICKUP'? (
                            <>{pageLanguageContents?.TilesContents[6]?.PricePickup}{" "}</>
                          ) : (
                              <>{pageLanguageContents?.TilesContents[5]?.PriceDelivery}{" "}</>
                            )} 
                          {pageLanguageContents?.PalletDetails[17]?.TargetPrice}:{" "}

                        {value?.displayCostToMarketPrice && value?.basePrice ? <CurrencyFormat
                          value={value?.basePrice.toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        /> : <span className={styles.perPallet}>N/A</span>
                        }
                  </p> */}

                  {/* <p className={styles.itemPrice}>
                    {tabType === "WishList" ? (
                      <>
                        Type:{" "}
                        <>{value.commodity?.commodityName  ? value.commodity.commodityName : 'Custom'} - {sizeAttach(tabType, value)}</>
                      </>
                    ) : (
                        <>
                        Type:{" "}
                        {value?.palletDetail?.commodity ? value?.palletDetail?.commodity :
                          value?.palletDetail?.material === 'PLASTIC' ? 'Plastic' :
                            'Custom'} - {sizeAttach(tabType, value)}
                        </>
                      )}
                  </p>                  */}
                  {/* <p className={styles.itemPrice}>
                    {pageLanguageContents?.TilesContents[10]?.Quantity}
                    {" "}{value?.sellAll ? (value?.palletDetail?.quantity / value?.lots).toLocaleString() : value?.palletDetail?.quantity.toLocaleString()}
                    &nbsp;{value?.sellAll && <LotsText>({value?.lots} lot)</LotsText>}
                  </p> */}
                  <p className={styles.itemPrice} style={{whiteSpace: 'nowrap'}}>{value?.deliveryType === 'PICKUP' ? "Must be Picked Up, " : "Willing to Deliver, "}{value?.sellAll ? (value?.palletDetail?.quantity / value?.lots).toLocaleString() : value?.palletDetail?.quantity.toLocaleString()} pallets</p>
                  <p className={styles.itemPrice}>
                    {pageLanguageContents?.PalletDetails[17]?.TargetPrice}:{" "}

                    {value?.displayCostToMarketPrice && value?.basePrice ? <CurrencyFormat
                      value={value?.basePrice.toFixed(2)}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                    /> : <span className={styles.perPallet}>N/A</span>
                    }
                  </p>
                  <div className={styles.rating}>
                    <RatingSection>
                      <span>{pageLanguageContents?.TilesContents[11]?.Rating}</span>{" "}
                      <Box
                        component="fieldset"
                        mb={3}
                        borderColor="transparent"
                      >
                        <Rating
                          name="simple-controlled"
                          value={value?.palletDetail?.fcMember ? 5 : 0}
                          onChange={(event, newValue) => { }}
                        />
                      </Box>
                    </RatingSection>
                  </div>
                </div>
                <Button>{pageLanguageContents?.TilesContents[12]?.ViewProduct}</Button>
                <div className={styles.overlay}></div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div>
          <div className={styles.noFound}>
            {setTimer && <h6>{pageLanguageContents?.TilesContents[13]?.NoRecord}</h6>}
          </div>
        </div>
      )}
    </div>
  );
}

export default Featured;

const RatingSection = styled.span`
    font-family: "latoregular";
    display: flex;
    gap: 10px;
    .MuiBox-root {
      margin-bottom: 0;
    }
`
const SellerIconWrapper = styled.span`
  > span {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 25px;
    height: 25px;
  }
  p {
    margin: 0;
    line-height: 12px;
  }
`;
const InnerCircleIconWrapper = styled.span`
  position: absolute;
  right: 29px;
  > span {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 25px;
    height: 25px;
  }
  p {
    margin: 0;
    line-height: 12px;
  }
`;
const DropdownContainer = styled.div`
  .custom-select__control {
    border-radius: 23px;
    box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
    border: solid 1px #fff;
    background-color: #fff;
    height: 40px;
  }
`;
const LotsText = styled.small`
  line-height: 24px;
  color: #FF7F00;
  font-family: "latosemibold";

  @media (max-width: 767px) {
    font-size: 11px;
  }
`;